// LOCAL COMPONENTS
import Card from 'parts/card/Card';
import Form from 'core/form/Form';

// DEPENDENCIES
import { compose } from 'redux';
import { useFormikContext } from 'formik';

// HELPERS
import { withRouter } from 'helpers/withRouter';

// GLOBAL FUNCTIONS
import { formatDollar } from 'functions.js';

// RENDER
const PurchaseInfoForm = compose(withRouter)(() => {
  const { values } = useFormikContext() || {};
  const { sale_type_name, lease_rate_reserve, lease_warranty_reserve } = values || {};
  return (
    <Form.Body>
      <Form.PlainText label="Purchase Type" name="sale_type_name" />
      <Form.PlainText label="Selling Price" name="selling_price" schema="dollars" />
      {sale_type_name === 'Lease' && (
        <>
          <Form.PlainText label="Lease Rate Reserve" value={`+ ${formatDollar(lease_rate_reserve || 0)}`} />
          <Form.PlainText label="Warranty Reserve" value={`+ ${formatDollar(lease_warranty_reserve || 0)}`} />
          <Form.PlainText label="Lease Split (F&amp;I %)" name="lease_gross_split" schema="percent" />
        </>
      )}
    </Form.Body>
  );
});

export default function PurchaseInfo(props) {
  return <Card title="Purchase Info" body={<PurchaseInfoForm {...props} />} />;
}
